<template>
    <div id="member-edit">
        <div id="member-edit-header">
            <img class="member-edit-back" src="../../assets/common_back.png" alt=""
                 @click="backBtn">
            <span class="member-edit-title">会员中心</span>

        </div>

        <div id="member-edit-body-bg">
            <div id="member-edit-body">
                <div style="height: 10px; width: 100%"></div>
                <div id="member-edit-line">

                    <div id="member-edit-body-header">
                        <div class="header-icon"> > </div>
                        <span style="color: #ed3f14; margin-left: 10px">修改资料</span>
                    </div>
                    <div id="description" style="">
                        （为方便以后找回密码，请补充邮箱信息）
                    </div>

                    <!--会员名-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_username_icon.png" alt="">
                                </div>

                                <span class="item-title">会员名</span>
                            </div>

                            <div class="item-description">
                                如果修改，不能为纯数字
                            </div>
                        </div>

                        <div class="item-input-box">
                            <input v-model="username" type="text" class="item-input" placeholder="请输入会员名" maxlength="10">
                        </div>
                    </div>

                    <!--密码-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_password_icon.png" alt="">
                                </div>

                                <span class="item-title">密码</span>
                            </div>

                            <div class="item-description">
                                如果不修改，请留空白
                            </div>
                        </div>

                        <div class="item-input-box">
                            <input type="password" class="item-input" placeholder="请输入您的密码" v-model="password" maxlength="20">
                        </div>
                    </div>

                    <!--密码确认-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_password_icon.png" alt="">
                                </div>

                                <span class="item-title">确认密码</span>
                            </div>

                            <div class="item-description">
                                <!--右侧对输入内容限制描述-->
                            </div>
                        </div>

                        <div class="item-input-box">
                            <input type="password" class="item-input" placeholder="请再次输入您的密码" v-model="confirmPassword" maxlength="20">
                        </div>
                    </div>

                    <!--真实姓名-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_username_icon.png" alt="">
                                </div>

                                <span class="item-title">真实姓名</span>
                            </div>

                            <div class="item-description">
                                只限中文姓名
                            </div>
                        </div>

                        <div class="item-input-box">
                            <input v-model="realName" type="text" class="item-input" placeholder="请输入真实姓名" @input="inputChange" maxlength="50">
                        </div>
                    </div>

                    <!--手机号码-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_username_icon.png" alt="">
                                </div>

                                <span class="item-title">手机号码</span>
                            </div>

                            <div class="item-description">
                                <!--右侧对输入内容限制描述-->
                            </div>
                        </div>

                        <div class="item-input-box">
                            <input v-model="mobile" type="text" class="item-input" placeholder="请输入手机号码" maxlength="11">
                        </div>

                        <div v-show="isCaptcha">
                            <div v-if="!isCaptchaNo" class="item-captcha" @click="sendCaptcha">
                                发送验证码
                            </div>
                            <div v-else class="item-captcha rest" >
                                {{ count }}s
                            </div>
                        </div>

                    </div>

                    <!--手机验证码-->
                    <div v-show="isCaptcha" class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_username_icon.png" alt="">
                                </div>

                                <span class="item-title">验证码</span>
                            </div>

                            <div class="item-description">
                                <!--右侧对输入内容限制描述-->
                            </div>
                        </div>

                        <div class="item-input-box">
                            <input v-model="captcha" type="text" class="item-input" placeholder="请输入验证码" maxlength="4">
                        </div>
                    </div>

                    <!--QQ-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_qq_icon.png" alt="">
                                </div>

                                <span class="item-title">QQ</span>
                            </div>

                            <div class="item-description">
                                <!--右侧对输入内容限制描述-->
                            </div>
                        </div>

                        <div class="item-input-box">
                            <input v-model="qq" type="text" class="item-input" placeholder="请输入您的QQ号码">
                        </div>
                    </div>

                    <!--E-mail-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_email_icon.png" alt="">
                                </div>

                                <span class="item-title">E-mail</span>
                            </div>

                            <div class="item-description">
                                填写邮箱便于找回密码
                            </div>
                        </div>

                        <div class="item-input-box">
                            <input v-model="email" type="text" class="item-input" placeholder="请输入您的电子邮箱">
                        </div>
                    </div>

                    <!--性别选择-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_sex_icon.png" alt="">
                                </div>

                                <span class="item-title">性别</span>
                            </div>

                            <div class="item-description">
                                <!--右侧对输入内容限制描述-->
                            </div>
                        </div>

                        <div class="radio-box" v-for="(item,index) in radios" :key="item.id">
                            <span class="radio" :class="{'on':item.isChecked}"></span>
                            <input v-model="sex" :value="item.value" class="input-radio" :checked='item.isChecked'  @click="check(index)" type="radio">{{item.label}}
                        </div>
                    </div>

                    <!--出生日期-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_birthday_icon.png" alt="">
                                </div>

                                <span class="item-title">出生日期</span>
                            </div>

                            <div class="item-description">
                                <!--右侧对输入内容限制描述-->
                            </div>
                        </div>
                    </div>

                    <date-select-components :yearInfo="year" :monthInfo="month" :dayInfo="day"/>

                    <!--居住地-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_birthday_icon.png" alt="">
                                </div>

                                <span class="item-title">居住地</span>
                            </div>

                            <div class="item-description">
                                <!--右侧对输入内容限制描述-->
                            </div>
                        </div>
                    </div>
                    <!--选择地区组件-->
                    <area-components @selectArea="getAreaId" :provinceProps ="province" :cityProps="city" :areaProps="area"/>

                    <!--联系地址-->
                    <div class="item">
                        <div class="item-header">
                            <div class="title-and-icon">
                                <div class="item-icon-bg">
                                    <img class="item-icon"
                                         src="../../assets/member_edit_password_icon.png" alt="">
                                </div>

                                <span class="item-title">联系地址</span>
                            </div>

                            <div class="item-description">
                                <!--右侧对输入内容限制描述-->
                            </div>
                        </div>

                        <div class="item-input-box">
                            <input v-model="contactAddress" type="text" class="item-input" placeholder="请输入您的联系地址">
                        </div>
                    </div>

                    <div style="margin-top: 10px; margin-bottom: 10px">
                        <span class="input-box-off"  :class="{'on': acceptEmail}"></span>
                        <input class="input-box" type="checkbox" v-model="acceptEmail" @change="emailBox">
                        <span class="input-txt">同意接受会员活动信息邮件</span>
                    </div>
                   <div>
                       <span class="input-box-off"  :class="{'on': acceptSms}"></span>
                       <input class="input-box" type="checkbox" v-model="acceptSms" @change="smsBox">
                       <span class="input-txt">同意免费接受会员活动短信</span>
                   </div>

                    <div id="member-edit-submit-box">
                        <button class="member-edit-submit-btn" @click="registerSubmit" :disabled="btnDisable">提交</button>
                    </div>

                    <div class="back-btn" @click="backBtn">返回</div>

                    <base-dialog v-show="messageVisible" :title="title" width="80%" @close="close">
                        <p>{{ message }}</p>
                    </base-dialog>

                    <div class="toast" v-show="toastShow">
                        {{toastText}}
                    </div>
                </div>
                <div style="height: 10px; width: 100%"></div>
            </div>
        </div>

        <div style="height: 10px"></div>
    </div>
</template>

<script>
    import AreaComponents from "../../components/AreaComponents";
    import DateSelectComponents from "../../components/DateSelectComponents";
    import {memberDetail, memberEdit} from "../../api/Member";
    import BaseDialog from "../../components/BaseDialog";
    import {SendCaptcha} from "../../api/Login";
    import md5 from 'js-md5'
    import {formatDate, parseTime, isNumber} from "@/unitls";

    export default {
        name: "MemberEditInfo",
        components: {AreaComponents, DateSelectComponents, BaseDialog},

        data() {
            return {
                id: '',
                username: '',
                usernameRest: '',
                password: '',
                confirmPassword: '',
                realName: '',
                mobile: '',
                oldMobile: '',
                captcha: '',
                qq: '',
                email: '',
                sex: '',
                birthday: '',
                province: '',
                city: '',
                area: '',
                contactAddress: '',
                acceptEmail: false,
                acceptSms: false,

                year: '',
                month: '',
                day: '',

                radios:[
                    {
                        label: '男',
                        value:'0',
                        isChecked: false,
                    },
                    {
                        label: '女',
                        value:'1',
                        isChecked: false,
                    },
                ],

                toastShow: false,
                toastText: '',

                title: '提示',
                messageVisible: false,
                message: "",

                isEdit: false,

                isCaptcha: false,
                isCaptchaNo: false,
                timer: null,
                count: '', //发送验证码倒计时

                btnDisable: false,
            }
        },

        mounted() {
            this.memberDetail()
        },

        methods: {
            //设置性别
            check(index) {
                // 先取消所有选中项
                this.radios.forEach((item) => {
                    item.isChecked = false;
                });
                //再设置当前点击项选中
                this.sex = this.radios[index].value;
                // 设置值，以供传递
                this.radios[index].isChecked = true;
            },


            backBtn() {
                this.$router.go(-1)
            },

            getAreaId(selectProvince, selectCity, selectArea) {
                this.province = selectProvince;
                this.city = selectCity;
                this.area = selectArea;
            },

            dateChange(obj) {
                this.birthday = new Date(obj.year,obj.month-1,obj.day,0,0,0).getTime();
            },

            registerSubmit() {
                this.memberEdit()
            },

            memberDetail() {
                memberDetail()
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.id = response.data.id;
                            this.memberName = response.data.memberName;
                            this.usernameRest = response.data.username;
                            this.username = response.data.username;
                            this.realName = response.data.realname;
                            this.mobile = response.data.mobile;
                            this.oldMobile = response.data.mobile;
                            this.qq = response.data.qq;
                            this.email = response.data.email;
                            this.sex = response.data.sex;
                            this.contactAddress = response.data.address;
                            this.area = response.data.area;
                            this.acceptEmail = response.data.acceptEmail;
                            this.acceptSms = response.data.acceptSms;
                            if (response.data.city !== '') {
                                let city = response.data.city.split('|');
                                this.province = city[0];
                                this.city = city[1];
                            }

                            if (this.sex === '0') {
                                this.check(0);
                            } else {
                                this.check(1);
                            }

                            if (response.data.birthday !== '') {
                                let birthday = parseTime(response.data.birthday);
                                let data = birthday.replace(/-/g, '/');
                                this.year = formatDate(data, 'yyyy');
                                this.month = formatDate(data, 'MM');
                                this.day = formatDate(data, 'dd');
                            } else {
                                this.year = "请选择";
                                this.month = "请选择";
                                this.day = "请选择";
                            }


                        }
                    })
            },

            close() {
                this.messageVisible = false;
                this.$emit('close');
            },

            toast (e) {
                let _that = this;
                this.toastText = e;
                this.toastShow = true;
                setTimeout(function(){
                    _that.toastShow = false;
                    if (_that.isEdit) {
                        _that.$router.go(-1);
                    }
                }, 1000)
            },

            memberEdit() {


                if (this.username !== this.usernameRest) {
                    var patrn = /^[0-9]*$/;
                    var reg = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
                    if(patrn.test(this.username)) {
                        this.toast('会员名不能为纯数字');
                        return;
                    }
                    if (reg.test(this.username)) {
                        this.toast("会员名不能包含表情符号");
                        return;
                    }
                } 
                
                if (this.password !== this.confirmPassword) {
                    this.toast("请确认密码是否正确");
                    return
                }

                if (this.password.trim().length < 6 && this.password.trim().length > 0) {
                    this.toast('密码长度必须6～20位');
                    return;
                }

                let requestPassword = '';
                if (this.password.trim() !== '') {
                    requestPassword = md5(this.password).substr(8,16);
                }

                if (this.realName === '') {
                    this.toast("请输入真实姓名");
                    return;
                }

                let regName = /[^\u4E00-\u9FA5]/g;
                if (regName.test(this.realName)) {
                    this.toast("真实姓名必须为汉字");
                    return;
                }

                if (this.realName.trim().length > 50) {
                    this.toast("真实姓名长度不能超过50个汉字");
                    return;
                }
                let telReg = /^1[3456789]\d{9}$/;
                if (!telReg.test(this.mobile)) {
                    this.toast("请输入正确的电话号码");
                    return;
                }

                if (!isNumber(this.qq) && this.qq.trim().length > 0) {
                    this.toast("qq号必须为数字");
                    return;
                }

                var regEmail = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/; //正则表达式
                if (!regEmail.test(this.email) && this.email.trim().length > 0) {
                    this.toast('邮箱格式不正确');
                    return;
                }

                if (!this.isCaptcha) {
                    this.mobile = '';
                } else {
                    if (this.captcha === '') {
                        this.toast("请输入验证码");
                        return;
                    }
                }

                this.btnDisable = true;
                memberEdit(
                    this.username,
                    this.realName,
                    this.mobile,
                    this.captcha,
                    this.email,
                    this.qq,
                    requestPassword,
                    this.sex,
                    this.birthday,
                    this.province,
                    this.city,
                    this.area,
                    this.contactAddress,
                    this.acceptEmail,
                    this.acceptSms)
                    .then(response => {
                        if (this.$API_CODE.OK === response.code) {
                            this.toast('会员信息修改成功');
                            this.isEdit = true;
                        } else {
                            this.btnDisable = false;
                            this.messageVisible = true;
                            this.message = response.message;
                        }
                })
            },

            sendCaptcha() {
                let telReg = /^1[3456789]\d{9}$/;
                if (!telReg.test(this.mobile)) {
                    this.toast("请输入正确的电话号码");
                    return;
                }
                SendCaptcha(this.mobile).then((response) => {
                    if (this.$API_CODE.OK === response.code) {
                        this.toast("验证码发送成功");

                        const TIME_COUNT = 60;
                        if (!this.timer) {
                            this.count = TIME_COUNT;
                            this.isCaptchaNo = true;
                            this.isCaptcha = true;
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= TIME_COUNT) {
                                    this.count--;
                                } else {
                                    this.isCaptchaNo = false;
                                    // this.isCaptcha = false;
                                    clearInterval(this.timer);
                                    this.timer = null;
                                }
                            }, 1000);
                        }
                    }
                })
            },

            emailBox() {
                if (!this.acceptEmail) {
                    this.acceptEmail = false;
                }  else {
                    this.acceptEmail = true;
                }
            },
            smsBox() {
                if (!this.acceptSms) {
                    this.acceptSms = false;
                }  else {
                    this.acceptSms = true;
                }
            },

            //限制输入框的内容只能为汉字
            inputChange(e) {
                const o = e.target;
                this.realName = o.value.replace(/[^\u4E00-\u9FA5]/g, '');
            },


        },

        watch: {
            mobile(curVal) {
                if (curVal === this.oldMobile) {
                    this.isCaptcha = false;
                } else {
                    if (this.mobile === '') {
                        this.isCaptcha = false;
                    } else {
                        this.isCaptcha = true;
                    }

                }
            }
        }
    }
</script>

<style scoped lang="scss">

    #member-edit {
        background-color: #f2f2f2;

        //header区域
        #member-edit-header {
            height: 45px;
            line-height: 45px;
            background-color: #ed3f14;

            .member-edit-back {
                margin-top: 13px;
                line-height: 35px;
                margin-left: 10px;
                float: left;
            }

            .member-edit-more {
                width: 16px;
                height: 16px;
                margin-top: 8px;
                line-height: 35px;
                margin-right: 10px;
                float: right;
            }

            .member-edit-title {
                color: white;
            }


        }

        //body区域
        #member-edit-body {
            margin: 30px 15px;
            border-radius: 15px;
            background-color: white;
            clear: both;
            font-size: 0.9rem;

            .header-icon {
                background: #ed3f14;
                border-radius: 90px;
                width: 20px;
                height: 20px;
                line-height: 20px;
                color: #FFFFFF;
                float: left;
                font-weight: bold;
            }

            //表单外面的红线
            #member-edit-line {
                border: 1px solid #ed3f14;
                margin: 10px;
                border-radius: 10px;

                //会员注册表单title
                #member-edit-body-header {
                    margin-left: 10px;
                    margin-top: 30px;
                    float: left;
                }

                #description {
                    clear: both;
                    color: #757575;
                    font-size: 10px
                }

                //整个输入框布局
                .item {
                    font-size: 0.9rem;
                    margin-left: 10px;
                    margin-right: 10px;

                    //头像，输入内容标题，对输入内容限制描述
                    .item-header {
                        margin-bottom: 10px;
                        height: 33px;
                        margin-top: 20px;

                        //左侧图片和输入项标题
                        .title-and-icon {
                            float: left;

                            //输入框标志图标背景及图片
                            .item-icon-bg {
                                width: 33px;
                                height: 33px;
                                border-radius: 20px;
                                background: #ed3f14;
                                float: left;

                                .item-icon {
                                    height: 15px;
                                    width: 15px;
                                    margin-top: 8px;
                                }
                            }

                            //输入内容小标题
                            .item-title {
                                line-height: 33px;
                                margin-left: 10px;
                            }
                        }

                        //右侧小灰色文字对内容限制描述
                        .item-description {
                            float: right;
                            font-size: 0.8rem;
                            color: #757575;
                            line-height: 33px;
                        }

                    }

                    //输入框
                    .item-input-box {
                        clear: both;
                        margin-top: 10px;
                        margin-right: 40px;

                        .item-input {
                            width: 100%;
                            border-top: 0;
                            border-left: 0;
                            border-right: 0;
                            margin-left: 40px;
                            border-bottom: 2px solid #ed3f14;
                            outline: none;
                            font-size: 0.85rem;
                        }

                    }

                    .item-captcha {
                        float: right;
                        background-color: #ed3f14;
                        border-radius: 5px;
                        height: 30px;
                        margin-top: 10px;
                        padding: 5px;
                        color: white;
                        font-weight: bold;
                        width: 90px;
                        line-height: 20px;
                    }

                    .rest {
                        background-color: #757575;
                    }

                    .radio-box{
                        display: inline-block;
                        position: relative;
                        height: 25px;
                        line-height: 25px;
                        margin-right: 25px;
                        width: 20%;
                        text-align: left;
                        margin-left: 25px;
                    }
                    .input-radio {
                        display: inline-block;
                        position: absolute;
                        opacity: 0;
                        width: 25px;
                        height: 25px;
                        left: 0px;
                        outline: none;
                        -webkit-appearance: none;
                    }
                    .radio {
                        display: inline-block;
                        width: 25px;
                        height: 25px;
                        vertical-align: middle;
                        background-image: url(../../assets/radio_off.png);
                        background-repeat: no-repeat;
                        //background-position: 0 0;
                        background-size: 100% 100%;
                        margin-top: -5px;
                        margin-right: 15px;
                    }
                    .on {
                        width: 20px;
                        height: 20px;
                        background-image: url(../../assets/radio_on.png);
                        background-size: 100% 100%;
                    }

                }

                .input-box {
                    display: inline-block;
                    position: absolute;
                    opacity: 0;
                    width: 25px;
                    height: 25px;
                    outline: none;
                    -webkit-appearance: none;
                    margin-top: -5px;
                }

                .input-box-off {
                    width: 25px;
                    height: 25px;
                    vertical-align: middle;
                    float: left;
                    position: absolute;
                    margin-top: -5px;
                    background-image: url(../../assets/check_box_outline_blank.png);
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                }

                .on {
                    background-image: url(../../assets/check_box_24px_rounded.png);
                    background-size: 100% 100%;
                }

                .input-txt {
                    margin-left: 30px;
                    font-size: 0.8rem;

                }


                #member-edit-submit-box {
                    margin-left: 15px;
                    margin-right: 15px;

                    .member-edit-submit-btn {
                        width: 100%;
                        height: 45px;
                        margin-top: 20px;
                        margin-bottom: 10px;
                        border: 0;
                        border-radius: 5px;
                        background-color: #ed3f14;
                        color: white;
                        font-size: 1rem;
                    }
                }
            }
        }

        .back-btn {
            margin: auto;
            width: 92%;
            font-size: 1rem;
            font-weight: bold;
            color: #ed3f14;
            border: 1px solid #ed3f14;
            border-radius: 5px;
            padding: 10px;
            margin-bottom: 20px;
        }

    }

</style>